export default {
  validation: {
    sanitizeEmail(email) {
      if (email === undefined || email === null) {
        return ''
      }

      return String(email)
        .trim()
        .toLowerCase()
    },
    email(email) {
      const sanitized = this.sanitizeEmail(email)

      if (!sanitized) {
        return false
      }

      // eslint-disable-next-line
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(sanitized)
    }
  },

  text: {
    formatHtml(text) {
      // eslint-disable-next-line
      if (text === undefined || text === null) {
        return ''
      }

      /* const tagsToReplace = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;'
      }

      text = text.replace(/[&<>]/g, tag => tagsToReplace[tag] || tag) */

      const breakTag = '<br>'
      return (text + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2')
    },

    formatTime(date, location) {
      const timeFormatOptions = {
        hour: 'numeric',
        minute: '2-digit'
      }

      const locale = location.locale.replace('_', '-')

      return date.toLocaleTimeString(locale, timeFormatOptions)
    },

    formatMinuteTime(time, location) {
      const hours = parseInt(time / 60)
      const minutes = time - (hours * 60)
      const date = new Date(Date.UTC(1970, 0, 1, hours, minutes, 0))
      const timeFormatOptions = {
        hour: 'numeric',
        minute: '2-digit',
        timeZone: 'UTC'
      }
      const locale = location.locale.replace('_', '-')
      return date.toLocaleTimeString(locale, timeFormatOptions)
    },

    stripPhoneNumber(text) {
      const input = String(text).trim();
      const normalized = input
        .replace(/^00+/, '+')      // turn 00... into +
        .replace(/[^\d+]/g, '')    // keep digits and +
        .replace(/(?!^)\+/g, '');  // remove any + not at start
        
      return normalized;
    }
  },

  date: {
    fromMinuteTime(time) {
      const hours = parseInt(time / 60)
      const minutes = time - (hours * 60)

      return new Date(2000, 0, 1, hours, minutes)
    }
  },

  browser: {
    inIframe() {
      try {
        return window.self !== window.top
      } catch (e) {
        return true
      }
    },

    // Detect nested iframe (iframe within another iframe, like Wix's embed setup)
    inNestedIframe() {
      try {
        return window.self !== window.top && window.parent !== window.top
      } catch (e) {
        return true // Cross-origin means we can't access, likely nested
      }
    },

    // Detect Safari browser
    isSafari() {
      if (typeof navigator === 'undefined') return false
      const ua = navigator.userAgent
      // Safari but not Chrome (Chrome also contains "Safari" in UA)
      return /Safari/.test(ua) && !/Chrome/.test(ua) && !/Chromium/.test(ua)
    },
  }
}
